import { View } from '@mirai/ui';
import React from 'react';

export const Step3 = () => <View data-mirai-component="booking" />;
